import { render } from "./AssociationList.vue?vue&type=template&id=49fd8536&ts=true"
import script from "./AssociationList.vue?vue&type=script&lang=ts"
export * from "./AssociationList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__